import {ReactComponent as Icon} from '@image/icon_battery.svg';

const IconBattery = () => {
    return   <Icon />;
};

export default IconBattery;